const Card = ({
    children,
    paddingClass = 'p-5',
    verticalSpace = 'space-y-4',
    shadow = 'shadow-lg',
    borderRadiusClass = 'rounded-xl',
    onClick = () => { },
    ...property
}) => {
    return (
        <div
            className={`items-center ${borderRadiusClass} bg-basicWhite ${shadow} ${property.className} ${paddingClass}`}
            style={{ boxShadow: property.boxShadow ? property.boxShadow : '' }}
            onClick={onClick}
        >
            <div className={verticalSpace}>{children}</div>
        </div>
    );
};

export default Card;
